import { render, staticRenderFns } from "./DriverStats.vue?vue&type=template&id=1d274f9c&scoped=true"
import script from "./DriverStats.vue?vue&type=script&lang=js"
export * from "./DriverStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d274f9c",
  null
  
)

export default component.exports